import React, { useState } from 'react';
// We don't need axios or useNotification here anymore
import { useCart } from '../../context/CartProvider'; // <-- Only import useCart

function AddToCartButton({ product, addItem }) {
  const [quantity, setQuantity] = useState(1);

  // This is now a very simple function
  const handleAddToCart = () => {
    // We just call the "smart" addItem function from our CartProvider.
    // It will handle all the stock checks and notifications.
    addItem({ ...product, quantity });
  };

  return product.stock_quantity > 0 ? (
    <div className="add-to-cart-wrapper">
      <input
        type="number"
        value={quantity}
        min="1"
        max={product.stock_quantity}
        onChange={(e) => setQuantity(parseInt(e.target.value, 10))}
        className="quantity-input"
      />
      <button className="add-to-cart" onClick={handleAddToCart}>
        Add to Cart
      </button>
    </div>
  ) : (
    <button className="sold-out" disabled>
      Sold Out
    </button>
  );
}

export default AddToCartButton;
